import * as yup from 'yup'
import { getI18n } from 'react-i18next'

export const validationSchema = yup.object({
  Name: yup.string(),
  Email: yup.string().email(getI18n().t('common:validation.email-format')),
  Phone: yup.number(),
})
